import { combineClassNames } from "@utils/appUtils";

import { WPTypogrpahy } from "@components/WPTypography";

import "./WPInputLabel.scss";

const WPInputLabel = ({ id, label, disabled, className, required, mandatory, asElement = "label" }) => {
  const Element = asElement;

  return (
    <>
      {label && (
        <Element
          className={combineClassNames("wp-input-label fs-14", disabled && "disabled", className)}
          {...(asElement === "label" && { htmlFor: id })}
          {...(asElement === "label" && { "data-test-id": id })}
        >
          {required && !mandatory && <WPTypogrpahy text='*' asElement='span' className='wp-input-required' />}
          {label}
        </Element>
      )}
    </>
  );
};

export default WPInputLabel;
